import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { captureAttribution } from "@/lib/attribution";

/**
 * Re-runs UTM capture on every route change (including query-string changes),
 * so that navigating to a URL like `/?utm_source=x` updates attribution.
 */
export function useAttributionTracker() {
  const location = useLocation();
  useEffect(() => {
    captureAttribution();
  }, [location.pathname, location.search]);
}